export function googleContactPlacesEnable(elementClassName) {
    var attr = document.getElementById(elementClassName).dataset,
        googleKey = attr.key,
        lat = parseFloat(attr.lat),
        long = parseFloat(attr.long);

    // Create the script tag, set the appropriate attributes
    var script = document.createElement('script');
    script.src =
        'https://maps.googleapis.com/maps/api/js?key=' +
        googleKey +
        '&callback=initMap';
    script.defer = true;
    script.async = true;

    /*eslint no-unused-vars: "off"*/
    /*eslint no-undef: "off"*/

    // Attach your callback function to the `window` object
    window.initMap = async function () {
        const { AdvancedMarkerElement } = await google.maps.importLibrary(
            'marker'
        );
        var map,
            coordinates = { lat: lat, lng: long };

        // JS API is loaded and available
        map = new google.maps.Map(document.getElementById('map'), {
            center: coordinates,
            zoom: 10,
            disableDefaultUI: true,
            draggable: false,
            mapId: googleKey
        });

        const pinElement = document.createElement('div');
        pinElement.className = 'google-maps-custom-pin';

        var marker = new AdvancedMarkerElement({
            position: coordinates,
            content: pinElement,
            map: map,
        });

        marker.setMap(map);
    };

    // Append the 'script' element to 'head'
    document.head.appendChild(script);
}

document.addEventListener('DOMContentLoaded', () => {

    if (document.getElementById('map')) {
        const className = 'map';
        googleContactPlacesEnable(className);
    }
});